// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"2f8beb54","308":"c41f7c9f","526":"0015121f","869":"81ffffb7","964":"7d5d8444"}[chunkId] + ".css";
};